module.exports = __webpack_public_path__ + "static/media/view other certificate.a3665b24.svg";